import { isFunction } from 'vessel/utils'

export default {
  inject: {
    $sessionForm: {
      default: null
    }
  },
  methods: {
    notify(data, inline = true) {
      this.$notify.closeAll()

      if (inline && this.$sessionForm) {
        this.$sessionForm.notify({
          type: data.status,
          title: data.notice,
          messages: data.messages
        })
      } else {
        const h = this.$createElement
        const messages = data.messages.map(message => {
          return h('p', message)
        })

        this.$notify({
          type: data.status,
          title: data.notice,
          message: h('div', messages || []),
          duration: (data.duration || 10) * 1000
        })
      }
    },
    notifyError(inline = true) {
      const object = {
        status: 'error',
        notice: this.$t('errors.generalError'),
        messages: [this.$t('errors.generalErrorText')]
      }

      if (inline && this.$sessionForm) {
        this.$sessionForm.notify(object)
      } else {
        this.notify(object)
      }
    },
    mutate(options) {
      this.$emit('loading', true)

      const success = options.success
      const failure = options.failure
      const errorfn = options.error

      const callFun = (fn, res) => isFunction(fn) && fn.call(this, res)

      const request = this.$graphql.mutate({
        mutation: options.mutation,
        variables: options.variables,
        clientId: 'oauth'
      })
      .then(({ fullData }) => {
        this.$emit('loading', false)

        const resKey = Object.keys(fullData)[0]
        const result = fullData[resKey] || {}

        if (options.notify !== false) {
          this.notify(result)
        }

        if (result.status === 'success') {
          callFun(success, result)
          this.$emit('success', result)
        } else {
          callFun(failure, result)
          this.$emit('error', result)
        }
      })
      .catch(error => {
        this.$emit('loading', false)

        if (isFunction(errorfn)) {
          errorfn.call(this, error)
        } else {
          this.notifyError()
        }

        this.$emit('error', error)
      })

      return request
    }
  }
}
